import type { ReactNode } from "react";

import type { WPNavigationLink } from "../../../../../models/WPNavigationLink";
import type {
  WPPageDescriptor,
  WPPageGroupDescriptor,
} from "../../../../../models/WPPageDescriptor";
import { BurgerButton } from "../../../../components/atoms/BurgerButton/BugerButton";
import { CSSRefTransition } from "../../../../components/atoms/transition.css";
import { useOverlay } from "../../../../hooks/effect/useOverlay";
import { useActivePagePath } from "../../../hooks/useActivePagePath";
import type { AppPage } from "../../../hooks/usePageFromRouter";

import { NavigationLink } from "./NavigationLink";
import * as styles from "./styles/MobileNavigation";

type Props = {
  page: AppPage | undefined;
  navigation:
    | Array<WPPageDescriptor | WPPageGroupDescriptor | WPNavigationLink>
    | undefined;
};

export function MobileNavigation({
  page,
  navigation,
}: Props): ReactNode | null {
  const overlay = useOverlay();

  const activePath = useActivePagePath();

  const activePage = page?.product
    ? navigation?.[0]
    : (page?.parentPageDescriptor ?? page?.pageDescriptor);

  return (
    <div className={styles.boundaryCls}>
      <div className={styles.wrapperCls}>
        <BurgerButton
          label={activePage?.title}
          toggled={overlay.isOpen}
          onClick={overlay.toggle}
        />
      </div>

      <CSSRefTransition
        in={overlay.isOpen}
        timeout={styles.overlayTransitionDurationMs}
        mountOnEnter
        unmountOnExit
      >
        {(ref) => (
          <div ref={ref} className={styles.overlayCls} onClick={overlay.close}>
            <div
              className={styles.popperCls}
              onClick={(evt) => {
                evt.stopPropagation();
              }}
            >
              <ul className={styles.linkListCls}>
                {navigation?.map((it, index) => (
                  <li key={index}>
                    <NavigationLink
                      activePath={activePath}
                      className={styles.linkCls}
                      model={it}
                      onClick={overlay.close}
                    />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </CSSRefTransition>
    </div>
  );
}
